// @generated by protoc-gen-es v2.5.1 with parameter "target=ts,json_types=true"
// @generated from file products/v1/service.proto (package products.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { PaginationArguments, PaginationArgumentsJson, PaginationPageInfo, PaginationPageInfoJson } from "../../common/v1/pagination_pb";
import { file_common_v1_pagination } from "../../common/v1/pagination_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { FieldMask, FieldMaskJson, StructJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
import type { PostalAddress, PostalAddressJson } from "../../google/type/postal_address_pb";
import { file_google_type_postal_address } from "../../google/type/postal_address_pb";
import type { Checkout, CheckoutJson, Integration, IntegrationJson, LineItem, LineItemJson, Order, OrderJson, Payment, PaymentInfo, PaymentInfoJson, PaymentJson, Product, ProductJson } from "./product_pb";
import { file_products_v1_product } from "./product_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file products/v1/service.proto.
 */
export const file_products_v1_service: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_common_v1_pagination, file_google_api_annotations, file_google_protobuf_field_mask, file_google_protobuf_struct, file_google_type_postal_address, file_products_v1_product],
	);

/**
 * @generated from message products.v1.Credentials
 */
export type Credentials = Message<"products.v1.Credentials"> & {
	/**
	 * @generated from field: string session_id = 1;
	 */
	sessionId: string;

	/**
	 * @generated from field: string access_token = 2;
	 */
	accessToken: string;

	/**
	 * @generated from field: string scope = 3;
	 */
	scope: string;
};

/**
 * @generated from message products.v1.Credentials
 */
export type CredentialsJson = {
	/**
	 * @generated from field: string session_id = 1;
	 */
	sessionId?: string;

	/**
	 * @generated from field: string access_token = 2;
	 */
	accessToken?: string;

	/**
	 * @generated from field: string scope = 3;
	 */
	scope?: string;
};

/**
 * Describes the message products.v1.Credentials.
 * Use `create(CredentialsSchema)` to create a new message.
 */
export const CredentialsSchema: GenMessage<Credentials, { jsonType: CredentialsJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 0);

/**
 * @generated from message products.v1.IntegrationFilter
 */
export type IntegrationFilter = Message<"products.v1.IntegrationFilter"> & {
	/**
	 * @generated from field: optional string integration_type = 1;
	 */
	integrationType?: string;

	/**
	 * @generated from field: optional string name = 2;
	 */
	name?: string;
};

/**
 * @generated from message products.v1.IntegrationFilter
 */
export type IntegrationFilterJson = {
	/**
	 * @generated from field: optional string integration_type = 1;
	 */
	integrationType?: string;

	/**
	 * @generated from field: optional string name = 2;
	 */
	name?: string;
};

/**
 * Describes the message products.v1.IntegrationFilter.
 * Use `create(IntegrationFilterSchema)` to create a new message.
 */
export const IntegrationFilterSchema: GenMessage<IntegrationFilter, { jsonType: IntegrationFilterJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 1);

/**
 * @generated from message products.v1.ListIntegrationsRequest
 */
export type ListIntegrationsRequest = Message<"products.v1.ListIntegrationsRequest"> & {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * @generated from field: products.v1.IntegrationFilter filter = 2;
	 */
	filter?: IntegrationFilter;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message products.v1.ListIntegrationsRequest
 */
export type ListIntegrationsRequestJson = {
	/**
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * @generated from field: products.v1.IntegrationFilter filter = 2;
	 */
	filter?: IntegrationFilterJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message products.v1.ListIntegrationsRequest.
 * Use `create(ListIntegrationsRequestSchema)` to create a new message.
 */
export const ListIntegrationsRequestSchema: GenMessage<ListIntegrationsRequest, { jsonType: ListIntegrationsRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 2);

/**
 * @generated from message products.v1.ListIntegrationsResponse
 */
export type ListIntegrationsResponse = Message<"products.v1.ListIntegrationsResponse"> & {
	/**
	 * @generated from field: repeated products.v1.Integration integrations = 1;
	 */
	integrations: Integration[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message products.v1.ListIntegrationsResponse
 */
export type ListIntegrationsResponseJson = {
	/**
	 * @generated from field: repeated products.v1.Integration integrations = 1;
	 */
	integrations?: IntegrationJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message products.v1.ListIntegrationsResponse.
 * Use `create(ListIntegrationsResponseSchema)` to create a new message.
 */
export const ListIntegrationsResponseSchema: GenMessage<ListIntegrationsResponse, { jsonType: ListIntegrationsResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 3);

/**
 * @generated from message products.v1.ProductFilter
 */
export type ProductFilter = Message<"products.v1.ProductFilter"> & {
	/**
	 * @generated from field: string title = 1;
	 */
	title: string;
};

/**
 * @generated from message products.v1.ProductFilter
 */
export type ProductFilterJson = {
	/**
	 * @generated from field: string title = 1;
	 */
	title?: string;
};

/**
 * Describes the message products.v1.ProductFilter.
 * Use `create(ProductFilterSchema)` to create a new message.
 */
export const ProductFilterSchema: GenMessage<ProductFilter, { jsonType: ProductFilterJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 4);

/**
 * @generated from message products.v1.ListProductsRequest
 */
export type ListProductsRequest = Message<"products.v1.ListProductsRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: products.v1.ProductFilter filter = 2;
	 */
	filter?: ProductFilter;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message products.v1.ListProductsRequest
 */
export type ListProductsRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: products.v1.ProductFilter filter = 2;
	 */
	filter?: ProductFilterJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 3;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message products.v1.ListProductsRequest.
 * Use `create(ListProductsRequestSchema)` to create a new message.
 */
export const ListProductsRequestSchema: GenMessage<ListProductsRequest, { jsonType: ListProductsRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 5);

/**
 * @generated from message products.v1.ListProductsResponse
 */
export type ListProductsResponse = Message<"products.v1.ListProductsResponse"> & {
	/**
	 * @generated from field: repeated products.v1.Product products = 1;
	 */
	products: Product[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message products.v1.ListProductsResponse
 */
export type ListProductsResponseJson = {
	/**
	 * @generated from field: repeated products.v1.Product products = 1;
	 */
	products?: ProductJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message products.v1.ListProductsResponse.
 * Use `create(ListProductsResponseSchema)` to create a new message.
 */
export const ListProductsResponseSchema: GenMessage<ListProductsResponse, { jsonType: ListProductsResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 6);

/**
 * @generated from message products.v1.GetProductRequest
 */
export type GetProductRequest = Message<"products.v1.GetProductRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * @generated from message products.v1.GetProductRequest
 */
export type GetProductRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message products.v1.GetProductRequest.
 * Use `create(GetProductRequestSchema)` to create a new message.
 */
export const GetProductRequestSchema: GenMessage<GetProductRequest, { jsonType: GetProductRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 7);

/**
 * @generated from message products.v1.GetProductResponse
 */
export type GetProductResponse = Message<"products.v1.GetProductResponse"> & {
	/**
	 * @generated from field: products.v1.Product product = 1;
	 */
	product?: Product;
};

/**
 * @generated from message products.v1.GetProductResponse
 */
export type GetProductResponseJson = {
	/**
	 * @generated from field: products.v1.Product product = 1;
	 */
	product?: ProductJson;
};

/**
 * Describes the message products.v1.GetProductResponse.
 * Use `create(GetProductResponseSchema)` to create a new message.
 */
export const GetProductResponseSchema: GenMessage<GetProductResponse, { jsonType: GetProductResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 8);

/**
 * @generated from message products.v1.GetRecommendationsRequest
 */
export type GetRecommendationsRequest = Message<"products.v1.GetRecommendationsRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;

	/**
	 * @generated from field: products.v1.RecommendationType recommendation_type = 3;
	 */
	recommendationType: RecommendationType;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArguments;
};

/**
 * @generated from message products.v1.GetRecommendationsRequest
 */
export type GetRecommendationsRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;

	/**
	 * @generated from field: products.v1.RecommendationType recommendation_type = 3;
	 */
	recommendationType?: RecommendationTypeJson;

	/**
	 * @generated from field: common.v1.PaginationArguments pagination = 4;
	 */
	pagination?: PaginationArgumentsJson;
};

/**
 * Describes the message products.v1.GetRecommendationsRequest.
 * Use `create(GetRecommendationsRequestSchema)` to create a new message.
 */
export const GetRecommendationsRequestSchema: GenMessage<GetRecommendationsRequest, { jsonType: GetRecommendationsRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 9);

/**
 * @generated from message products.v1.GetRecommendationsResponse
 */
export type GetRecommendationsResponse = Message<"products.v1.GetRecommendationsResponse"> & {
	/**
	 * @generated from field: repeated products.v1.Product products = 1;
	 */
	products: Product[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfo;
};

/**
 * @generated from message products.v1.GetRecommendationsResponse
 */
export type GetRecommendationsResponseJson = {
	/**
	 * @generated from field: repeated products.v1.Product products = 1;
	 */
	products?: ProductJson[];

	/**
	 * @generated from field: common.v1.PaginationPageInfo page_info = 2;
	 */
	pageInfo?: PaginationPageInfoJson;
};

/**
 * Describes the message products.v1.GetRecommendationsResponse.
 * Use `create(GetRecommendationsResponseSchema)` to create a new message.
 */
export const GetRecommendationsResponseSchema: GenMessage<GetRecommendationsResponse, { jsonType: GetRecommendationsResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 10);

/**
 * @generated from message products.v1.DeleteProductRequest
 */
export type DeleteProductRequest = Message<"products.v1.DeleteProductRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * @generated from message products.v1.DeleteProductRequest
 */
export type DeleteProductRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message products.v1.DeleteProductRequest.
 * Use `create(DeleteProductRequestSchema)` to create a new message.
 */
export const DeleteProductRequestSchema: GenMessage<DeleteProductRequest, { jsonType: DeleteProductRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 11);

/**
 * @generated from message products.v1.DeleteProductResponse
 */
export type DeleteProductResponse = Message<"products.v1.DeleteProductResponse"> & {};

/**
 * @generated from message products.v1.DeleteProductResponse
 */
export type DeleteProductResponseJson = {};

/**
 * Describes the message products.v1.DeleteProductResponse.
 * Use `create(DeleteProductResponseSchema)` to create a new message.
 */
export const DeleteProductResponseSchema: GenMessage<DeleteProductResponse, { jsonType: DeleteProductResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 12);

/**
 * @generated from message products.v1.UpdateProductRequest
 */
export type UpdateProductRequest = Message<"products.v1.UpdateProductRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: products.v1.Product product = 2;
	 */
	product?: Product;
};

/**
 * @generated from message products.v1.UpdateProductRequest
 */
export type UpdateProductRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: products.v1.Product product = 2;
	 */
	product?: ProductJson;
};

/**
 * Describes the message products.v1.UpdateProductRequest.
 * Use `create(UpdateProductRequestSchema)` to create a new message.
 */
export const UpdateProductRequestSchema: GenMessage<UpdateProductRequest, { jsonType: UpdateProductRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 13);

/**
 * @generated from message products.v1.UpdateProductResponse
 */
export type UpdateProductResponse = Message<"products.v1.UpdateProductResponse"> & {
	/**
	 * @generated from field: products.v1.Product product = 1;
	 */
	product?: Product;
};

/**
 * @generated from message products.v1.UpdateProductResponse
 */
export type UpdateProductResponseJson = {
	/**
	 * @generated from field: products.v1.Product product = 1;
	 */
	product?: ProductJson;
};

/**
 * Describes the message products.v1.UpdateProductResponse.
 * Use `create(UpdateProductResponseSchema)` to create a new message.
 */
export const UpdateProductResponseSchema: GenMessage<UpdateProductResponse, { jsonType: UpdateProductResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 14);

/**
 * @generated from message products.v1.CreateIntegrationRequest
 */
export type CreateIntegrationRequest = Message<"products.v1.CreateIntegrationRequest"> & {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: Integration;

	/**
	 * @generated from field: products.v1.Credentials credentials = 2;
	 */
	credentials?: Credentials;
};

/**
 * @generated from message products.v1.CreateIntegrationRequest
 */
export type CreateIntegrationRequestJson = {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: IntegrationJson;

	/**
	 * @generated from field: products.v1.Credentials credentials = 2;
	 */
	credentials?: CredentialsJson;
};

/**
 * Describes the message products.v1.CreateIntegrationRequest.
 * Use `create(CreateIntegrationRequestSchema)` to create a new message.
 */
export const CreateIntegrationRequestSchema: GenMessage<CreateIntegrationRequest, { jsonType: CreateIntegrationRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 15);

/**
 * @generated from message products.v1.CreateIntegrationResponse
 */
export type CreateIntegrationResponse = Message<"products.v1.CreateIntegrationResponse"> & {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: Integration;
};

/**
 * @generated from message products.v1.CreateIntegrationResponse
 */
export type CreateIntegrationResponseJson = {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: IntegrationJson;
};

/**
 * Describes the message products.v1.CreateIntegrationResponse.
 * Use `create(CreateIntegrationResponseSchema)` to create a new message.
 */
export const CreateIntegrationResponseSchema: GenMessage<CreateIntegrationResponse, { jsonType: CreateIntegrationResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 16);

/**
 * @generated from message products.v1.UpdateIntegrationRequest
 */
export type UpdateIntegrationRequest = Message<"products.v1.UpdateIntegrationRequest"> & {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: Integration;
};

/**
 * @generated from message products.v1.UpdateIntegrationRequest
 */
export type UpdateIntegrationRequestJson = {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: IntegrationJson;
};

/**
 * Describes the message products.v1.UpdateIntegrationRequest.
 * Use `create(UpdateIntegrationRequestSchema)` to create a new message.
 */
export const UpdateIntegrationRequestSchema: GenMessage<UpdateIntegrationRequest, { jsonType: UpdateIntegrationRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 17);

/**
 * @generated from message products.v1.UpdateIntegrationResponse
 */
export type UpdateIntegrationResponse = Message<"products.v1.UpdateIntegrationResponse"> & {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: Integration;
};

/**
 * @generated from message products.v1.UpdateIntegrationResponse
 */
export type UpdateIntegrationResponseJson = {
	/**
	 * @generated from field: products.v1.Integration integration = 1;
	 */
	integration?: IntegrationJson;
};

/**
 * Describes the message products.v1.UpdateIntegrationResponse.
 * Use `create(UpdateIntegrationResponseSchema)` to create a new message.
 */
export const UpdateIntegrationResponseSchema: GenMessage<UpdateIntegrationResponse, { jsonType: UpdateIntegrationResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 18);

/**
 * @generated from message products.v1.DeleteIntegrationRequest
 */
export type DeleteIntegrationRequest = Message<"products.v1.DeleteIntegrationRequest"> & {
	/**
	 * @generated from field: string integration_type = 1;
	 */
	integrationType: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * @generated from message products.v1.DeleteIntegrationRequest
 */
export type DeleteIntegrationRequestJson = {
	/**
	 * @generated from field: string integration_type = 1;
	 */
	integrationType?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message products.v1.DeleteIntegrationRequest.
 * Use `create(DeleteIntegrationRequestSchema)` to create a new message.
 */
export const DeleteIntegrationRequestSchema: GenMessage<DeleteIntegrationRequest, { jsonType: DeleteIntegrationRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 19);

/**
 * @generated from message products.v1.DeleteIntegrationResponse
 */
export type DeleteIntegrationResponse = Message<"products.v1.DeleteIntegrationResponse"> & {};

/**
 * @generated from message products.v1.DeleteIntegrationResponse
 */
export type DeleteIntegrationResponseJson = {};

/**
 * Describes the message products.v1.DeleteIntegrationResponse.
 * Use `create(DeleteIntegrationResponseSchema)` to create a new message.
 */
export const DeleteIntegrationResponseSchema: GenMessage<DeleteIntegrationResponse, { jsonType: DeleteIntegrationResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 20);

/**
 * @generated from message products.v1.BeginCheckoutRequest
 */
export type BeginCheckoutRequest = Message<"products.v1.BeginCheckoutRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string country_code = 2;
	 */
	countryCode: string;

	/**
	 * @generated from field: string first_name = 3;
	 */
	firstName: string;

	/**
	 * @generated from field: string last_name = 4;
	 */
	lastName: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email: string;

	/**
	 * @generated from field: string phone = 6;
	 */
	phone: string;

	/**
	 * @generated from field: repeated products.v1.LineItem line_items = 7;
	 */
	lineItems: LineItem[];

	/**
	 * @generated from field: google.type.PostalAddress shipping_address = 8;
	 */
	shippingAddress?: PostalAddress;

	/**
	 * @generated from field: bool requires_shipping = 9;
	 */
	requiresShipping: boolean;
};

/**
 * @generated from message products.v1.BeginCheckoutRequest
 */
export type BeginCheckoutRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string country_code = 2;
	 */
	countryCode?: string;

	/**
	 * @generated from field: string first_name = 3;
	 */
	firstName?: string;

	/**
	 * @generated from field: string last_name = 4;
	 */
	lastName?: string;

	/**
	 * @generated from field: string email = 5;
	 */
	email?: string;

	/**
	 * @generated from field: string phone = 6;
	 */
	phone?: string;

	/**
	 * @generated from field: repeated products.v1.LineItem line_items = 7;
	 */
	lineItems?: LineItemJson[];

	/**
	 * @generated from field: google.type.PostalAddress shipping_address = 8;
	 */
	shippingAddress?: PostalAddressJson;

	/**
	 * @generated from field: bool requires_shipping = 9;
	 */
	requiresShipping?: boolean;
};

/**
 * Describes the message products.v1.BeginCheckoutRequest.
 * Use `create(BeginCheckoutRequestSchema)` to create a new message.
 */
export const BeginCheckoutRequestSchema: GenMessage<BeginCheckoutRequest, { jsonType: BeginCheckoutRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 21);

/**
 * @generated from message products.v1.GetCheckoutRequest
 */
export type GetCheckoutRequest = Message<"products.v1.GetCheckoutRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * @generated from message products.v1.GetCheckoutRequest
 */
export type GetCheckoutRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message products.v1.GetCheckoutRequest.
 * Use `create(GetCheckoutRequestSchema)` to create a new message.
 */
export const GetCheckoutRequestSchema: GenMessage<GetCheckoutRequest, { jsonType: GetCheckoutRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 22);

/**
 * @generated from message products.v1.GetCheckoutResponse
 */
export type GetCheckoutResponse = Message<"products.v1.GetCheckoutResponse"> & {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: Checkout;
};

/**
 * @generated from message products.v1.GetCheckoutResponse
 */
export type GetCheckoutResponseJson = {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: CheckoutJson;
};

/**
 * Describes the message products.v1.GetCheckoutResponse.
 * Use `create(GetCheckoutResponseSchema)` to create a new message.
 */
export const GetCheckoutResponseSchema: GenMessage<GetCheckoutResponse, { jsonType: GetCheckoutResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 23);

/**
 * @generated from message products.v1.GetPaymentRequest
 */
export type GetPaymentRequest = Message<"products.v1.GetPaymentRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id: string;
};

/**
 * @generated from message products.v1.GetPaymentRequest
 */
export type GetPaymentRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string id = 2;
	 */
	id?: string;
};

/**
 * Describes the message products.v1.GetPaymentRequest.
 * Use `create(GetPaymentRequestSchema)` to create a new message.
 */
export const GetPaymentRequestSchema: GenMessage<GetPaymentRequest, { jsonType: GetPaymentRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 24);

/**
 * @generated from message products.v1.GetPaymentResponse
 */
export type GetPaymentResponse = Message<"products.v1.GetPaymentResponse"> & {
	/**
	 * @generated from field: products.v1.Payment payment = 1;
	 */
	payment?: Payment;
};

/**
 * @generated from message products.v1.GetPaymentResponse
 */
export type GetPaymentResponseJson = {
	/**
	 * @generated from field: products.v1.Payment payment = 1;
	 */
	payment?: PaymentJson;
};

/**
 * Describes the message products.v1.GetPaymentResponse.
 * Use `create(GetPaymentResponseSchema)` to create a new message.
 */
export const GetPaymentResponseSchema: GenMessage<GetPaymentResponse, { jsonType: GetPaymentResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 25);

/**
 * @generated from message products.v1.BeginCheckoutResponse
 */
export type BeginCheckoutResponse = Message<"products.v1.BeginCheckoutResponse"> & {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: Checkout;
};

/**
 * @generated from message products.v1.BeginCheckoutResponse
 */
export type BeginCheckoutResponseJson = {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: CheckoutJson;
};

/**
 * Describes the message products.v1.BeginCheckoutResponse.
 * Use `create(BeginCheckoutResponseSchema)` to create a new message.
 */
export const BeginCheckoutResponseSchema: GenMessage<BeginCheckoutResponse, { jsonType: BeginCheckoutResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 26);

/**
 * @generated from message products.v1.UpdateCheckoutRequest
 */
export type UpdateCheckoutRequest = Message<"products.v1.UpdateCheckoutRequest"> & {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: Checkout;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMask;
};

/**
 * @generated from message products.v1.UpdateCheckoutRequest
 */
export type UpdateCheckoutRequestJson = {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: CheckoutJson;

	/**
	 * @generated from field: google.protobuf.FieldMask mask = 2;
	 */
	mask?: FieldMaskJson;
};

/**
 * Describes the message products.v1.UpdateCheckoutRequest.
 * Use `create(UpdateCheckoutRequestSchema)` to create a new message.
 */
export const UpdateCheckoutRequestSchema: GenMessage<UpdateCheckoutRequest, { jsonType: UpdateCheckoutRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 27);

/**
 * @generated from message products.v1.UpdateCheckoutResponse
 */
export type UpdateCheckoutResponse = Message<"products.v1.UpdateCheckoutResponse"> & {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: Checkout;
};

/**
 * @generated from message products.v1.UpdateCheckoutResponse
 */
export type UpdateCheckoutResponseJson = {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: CheckoutJson;
};

/**
 * Describes the message products.v1.UpdateCheckoutResponse.
 * Use `create(UpdateCheckoutResponseSchema)` to create a new message.
 */
export const UpdateCheckoutResponseSchema: GenMessage<UpdateCheckoutResponse, { jsonType: UpdateCheckoutResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 28);

/**
 * @generated from message products.v1.CompleteCheckoutRequest
 */
export type CompleteCheckoutRequest = Message<"products.v1.CompleteCheckoutRequest"> & {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: Checkout;

	/**
	 * @generated from field: products.v1.PaymentInfo payment_info = 2;
	 */
	paymentInfo?: PaymentInfo;
};

/**
 * @generated from message products.v1.CompleteCheckoutRequest
 */
export type CompleteCheckoutRequestJson = {
	/**
	 * @generated from field: products.v1.Checkout checkout = 1;
	 */
	checkout?: CheckoutJson;

	/**
	 * @generated from field: products.v1.PaymentInfo payment_info = 2;
	 */
	paymentInfo?: PaymentInfoJson;
};

/**
 * Describes the message products.v1.CompleteCheckoutRequest.
 * Use `create(CompleteCheckoutRequestSchema)` to create a new message.
 */
export const CompleteCheckoutRequestSchema: GenMessage<CompleteCheckoutRequest, { jsonType: CompleteCheckoutRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 29);

/**
 * @generated from message products.v1.CompleteCheckoutResponse
 */
export type CompleteCheckoutResponse = Message<"products.v1.CompleteCheckoutResponse"> & {
	/**
	 * @generated from field: products.v1.Order order = 1;
	 */
	order?: Order;
};

/**
 * @generated from message products.v1.CompleteCheckoutResponse
 */
export type CompleteCheckoutResponseJson = {
	/**
	 * @generated from field: products.v1.Order order = 1;
	 */
	order?: OrderJson;
};

/**
 * Describes the message products.v1.CompleteCheckoutResponse.
 * Use `create(CompleteCheckoutResponseSchema)` to create a new message.
 */
export const CompleteCheckoutResponseSchema: GenMessage<CompleteCheckoutResponse, { jsonType: CompleteCheckoutResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 30);

/**
 * @generated from message products.v1.CreateApplePaySessionRequest
 */
export type CreateApplePaySessionRequest = Message<"products.v1.CreateApplePaySessionRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string validation_url = 2;
	 */
	validationUrl: string;
};

/**
 * @generated from message products.v1.CreateApplePaySessionRequest
 */
export type CreateApplePaySessionRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string validation_url = 2;
	 */
	validationUrl?: string;
};

/**
 * Describes the message products.v1.CreateApplePaySessionRequest.
 * Use `create(CreateApplePaySessionRequestSchema)` to create a new message.
 */
export const CreateApplePaySessionRequestSchema: GenMessage<CreateApplePaySessionRequest, { jsonType: CreateApplePaySessionRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 31);

/**
 * @generated from message products.v1.CreateApplePaySessionResponse
 */
export type CreateApplePaySessionResponse = Message<"products.v1.CreateApplePaySessionResponse"> & {
	/**
	 * @generated from field: google.protobuf.Struct session = 1;
	 */
	session?: JsonObject;
};

/**
 * @generated from message products.v1.CreateApplePaySessionResponse
 */
export type CreateApplePaySessionResponseJson = {
	/**
	 * @generated from field: google.protobuf.Struct session = 1;
	 */
	session?: StructJson;
};

/**
 * Describes the message products.v1.CreateApplePaySessionResponse.
 * Use `create(CreateApplePaySessionResponseSchema)` to create a new message.
 */
export const CreateApplePaySessionResponseSchema: GenMessage<CreateApplePaySessionResponse, { jsonType: CreateApplePaySessionResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 32);

/**
 * @generated from message products.v1.CreateOrderRequest
 */
export type CreateOrderRequest = Message<"products.v1.CreateOrderRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: products.v1.Order order = 2;
	 */
	order?: Order;
};

/**
 * @generated from message products.v1.CreateOrderRequest
 */
export type CreateOrderRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: products.v1.Order order = 2;
	 */
	order?: OrderJson;
};

/**
 * Describes the message products.v1.CreateOrderRequest.
 * Use `create(CreateOrderRequestSchema)` to create a new message.
 */
export const CreateOrderRequestSchema: GenMessage<CreateOrderRequest, { jsonType: CreateOrderRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 33);

/**
 * @generated from message products.v1.CreateOrderResponse
 */
export type CreateOrderResponse = Message<"products.v1.CreateOrderResponse"> & {
	/**
	 * @generated from field: products.v1.Order order = 1;
	 */
	order?: Order;
};

/**
 * @generated from message products.v1.CreateOrderResponse
 */
export type CreateOrderResponseJson = {
	/**
	 * @generated from field: products.v1.Order order = 1;
	 */
	order?: OrderJson;
};

/**
 * Describes the message products.v1.CreateOrderResponse.
 * Use `create(CreateOrderResponseSchema)` to create a new message.
 */
export const CreateOrderResponseSchema: GenMessage<CreateOrderResponse, { jsonType: CreateOrderResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 34);

/**
 * @generated from message products.v1.CreateCartPermalinkRequest
 */
export type CreateCartPermalinkRequest = Message<"products.v1.CreateCartPermalinkRequest"> & {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId: string;

	/**
	 * @generated from field: string variant_id = 2;
	 */
	variantId: string;

	/**
	 * @generated from field: int64 quantity = 3;
	 */
	quantity: bigint;

	/**
	 * @generated from field: map<string, string> attributes = 4;
	 */
	attributes: { [key: string]: string };
};

/**
 * @generated from message products.v1.CreateCartPermalinkRequest
 */
export type CreateCartPermalinkRequestJson = {
	/**
	 * @generated from field: string integration_id = 1;
	 */
	integrationId?: string;

	/**
	 * @generated from field: string variant_id = 2;
	 */
	variantId?: string;

	/**
	 * @generated from field: int64 quantity = 3;
	 */
	quantity?: string;

	/**
	 * @generated from field: map<string, string> attributes = 4;
	 */
	attributes?: { [key: string]: string };
};

/**
 * Describes the message products.v1.CreateCartPermalinkRequest.
 * Use `create(CreateCartPermalinkRequestSchema)` to create a new message.
 */
export const CreateCartPermalinkRequestSchema: GenMessage<CreateCartPermalinkRequest, { jsonType: CreateCartPermalinkRequestJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 35);

/**
 * @generated from message products.v1.CreateCartPermalinkResponse
 */
export type CreateCartPermalinkResponse = Message<"products.v1.CreateCartPermalinkResponse"> & {
	/**
	 * @generated from field: string url = 1;
	 */
	url: string;
};

/**
 * @generated from message products.v1.CreateCartPermalinkResponse
 */
export type CreateCartPermalinkResponseJson = {
	/**
	 * @generated from field: string url = 1;
	 */
	url?: string;
};

/**
 * Describes the message products.v1.CreateCartPermalinkResponse.
 * Use `create(CreateCartPermalinkResponseSchema)` to create a new message.
 */
export const CreateCartPermalinkResponseSchema: GenMessage<CreateCartPermalinkResponse, { jsonType: CreateCartPermalinkResponseJson }> = /*@__PURE__*/ messageDesc(file_products_v1_service, 36);

/**
 * @generated from enum products.v1.RecommendationType
 */
export enum RecommendationType {
	/**
	 * @generated from enum value: RECOMMENDATION_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: RECOMMENDATION_TYPE_RELATED = 1;
	 */
	RELATED = 1,

	/**
	 * @generated from enum value: RECOMMENDATION_TYPE_COMPLEMENTARY = 2;
	 */
	COMPLEMENTARY = 2,
}

/**
 * @generated from enum products.v1.RecommendationType
 */
export type RecommendationTypeJson = "RECOMMENDATION_TYPE_UNSPECIFIED" | "RECOMMENDATION_TYPE_RELATED" | "RECOMMENDATION_TYPE_COMPLEMENTARY";

/**
 * Describes the enum products.v1.RecommendationType.
 */
export const RecommendationTypeSchema: GenEnum<RecommendationType, RecommendationTypeJson> = /*@__PURE__*/ enumDesc(file_products_v1_service, 0);

/**
 * @generated from service products.v1.ProductService
 */
export const ProductService: GenService<{
	/**
	 * @generated from rpc products.v1.ProductService.CreateIntegration
	 */
	createIntegration: {
		methodKind: "unary";
		input: typeof CreateIntegrationRequestSchema;
		output: typeof CreateIntegrationResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.UpdateIntegration
	 */
	updateIntegration: {
		methodKind: "unary";
		input: typeof UpdateIntegrationRequestSchema;
		output: typeof UpdateIntegrationResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.DeleteIntegration
	 */
	deleteIntegration: {
		methodKind: "unary";
		input: typeof DeleteIntegrationRequestSchema;
		output: typeof DeleteIntegrationResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.ListIntegrations
	 */
	listIntegrations: {
		methodKind: "unary";
		input: typeof ListIntegrationsRequestSchema;
		output: typeof ListIntegrationsResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.ListProducts
	 */
	listProducts: {
		methodKind: "unary";
		input: typeof ListProductsRequestSchema;
		output: typeof ListProductsResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.GetProduct
	 */
	getProduct: {
		methodKind: "unary";
		input: typeof GetProductRequestSchema;
		output: typeof GetProductResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.UpdateProduct
	 */
	updateProduct: {
		methodKind: "unary";
		input: typeof UpdateProductRequestSchema;
		output: typeof UpdateProductResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.DeleteProduct
	 */
	deleteProduct: {
		methodKind: "unary";
		input: typeof DeleteProductRequestSchema;
		output: typeof DeleteProductResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.CreateOrder
	 */
	createOrder: {
		methodKind: "unary";
		input: typeof CreateOrderRequestSchema;
		output: typeof CreateOrderResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.GetRecommendations
	 */
	getRecommendations: {
		methodKind: "unary";
		input: typeof GetRecommendationsRequestSchema;
		output: typeof GetRecommendationsResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.GetCheckout
	 */
	getCheckout: {
		methodKind: "unary";
		input: typeof GetCheckoutRequestSchema;
		output: typeof GetCheckoutResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.BeginCheckout
	 */
	beginCheckout: {
		methodKind: "unary";
		input: typeof BeginCheckoutRequestSchema;
		output: typeof BeginCheckoutResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.UpdateCheckout
	 */
	updateCheckout: {
		methodKind: "unary";
		input: typeof UpdateCheckoutRequestSchema;
		output: typeof UpdateCheckoutResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.CompleteCheckout
	 */
	completeCheckout: {
		methodKind: "unary";
		input: typeof CompleteCheckoutRequestSchema;
		output: typeof CompleteCheckoutResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.GetPayment
	 */
	getPayment: {
		methodKind: "unary";
		input: typeof GetPaymentRequestSchema;
		output: typeof GetPaymentResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.CreateApplePaySession
	 */
	createApplePaySession: {
		methodKind: "unary";
		input: typeof CreateApplePaySessionRequestSchema;
		output: typeof CreateApplePaySessionResponseSchema;
	};
	/**
	 * @generated from rpc products.v1.ProductService.CreateCartPermalink
	 */
	createCartPermalink: {
		methodKind: "unary";
		input: typeof CreateCartPermalinkRequestSchema;
		output: typeof CreateCartPermalinkResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_products_v1_service, 0);
